import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AdminCtx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/me");
      setAdmin(data);
    } catch {
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = async () => {
    try { await api.post("/admin/logout"); } catch { /* ignore */ }
    setAdmin(null);
  };

  return (
    <AdminCtx.Provider value={{ admin, loading, refresh, logout, setAdmin }}>
      {children}
    </AdminCtx.Provider>
  );
};

export const useAdmin = () => useContext(AdminCtx);
